import { experience, education } from "../data/profile";
import { Reveal, Overline, AnimatedHeading } from "./Reveal";
import { GraduationCap } from "lucide-react";

export const Experience = () => (
  <section id="experience" className="py-16 sm:py-20 lg:py-24 bg-white border-y border-[#E2E5E1]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8">
          <Reveal>
            <Overline>Career Journey</Overline>
            <AnimatedHeading className="font-display text-3xl sm:text-4xl font-bold text-navy tracking-tight mt-4">
              Professional Experience
            </AnimatedHeading>
          </Reveal>

          <div className="mt-12 relative">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[#E2E5E1]" />
            <div className="space-y-10">
              {experience.map((x, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <div className="relative pl-10 group" data-testid={`experience-item-${i}`}>
                    <span className={`absolute left-0 top-1.5 h-4 w-4 rounded-full border-2 transition-all duration-300 group-hover:scale-150 ${i === 0 ? "bg-gold border-gold animate-pulse-ring" : "bg-white border-navy group-hover:bg-gold group-hover:border-gold"}`} />
                    <p className="text-xs font-plex uppercase tracking-widest text-gold">{x.period}</p>
                    <h3 className="font-display text-xl font-bold text-navy mt-1 group-hover:text-teal transition-colors">{x.role}</h3>
                    <p className="text-sm font-medium text-teal mt-0.5">{x.org}</p>
                    <p className="text-sm mt-2" style={{ color: "#4B5A69" }}>{x.detail}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <div className="lg:col-span-4">
          <Reveal delay={0.1}>
            <div className="lg:sticky lg:top-28 bg-bone border border-[#E2E5E1] rounded-2xl p-8">
              <div className="flex items-center gap-3">
                <GraduationCap className="text-teal" size={24} />
                <h3 className="font-display text-xl font-bold text-navy">Education</h3>
              </div>
              <div className="mt-6 space-y-6">
                {education.map((ed) => (
                  <div key={ed.degree} className="border-l-2 border-gold pl-4">
                    <p className="text-xs font-plex text-gold">{ed.year}</p>
                    <p className="font-semibold text-navy text-sm mt-1">{ed.degree}</p>
                    <p className="text-sm" style={{ color: "#4B5A69" }}>{ed.school}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
